import { useEffect, useState } from 'react';

const DEFAULT_BREAKPOINT = 768; // px

export default function useIsNarrowScreen(breakpoint = DEFAULT_BREAKPOINT) {
    const [isNarrow, setIsNarrow] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth <= breakpoint;
    });

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        const handleResize = () => {
            setIsNarrow(window.innerWidth <= breakpoint);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isNarrow;
}
